const FormatDate = ({rawDate}) => {
    if (!rawDate) return null
    const [year, month, day] = rawDate.split('-');
    return `${month}-${day}-${year}`;
}

export default FormatDate;